/* ─── REVEAL ─────────────────────────────────────────────────── */
const obs = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
}), { threshold: .08, rootMargin: '0px 0px -32px 0px' });
document.querySelectorAll('.rv').forEach(el => obs.observe(el));

/* ─── SCROLL TOP ─────────────────────────────────────────────── */
const upBtn = document.getElementById('up-art');
if (upBtn) {
  addEventListener('scroll', () => upBtn.classList.toggle('on', scrollY > 400), { passive: true });
  upBtn.onclick = () => scrollTo({ top: 0, behavior: 'smooth' });
}

/* ─── NORMALISATION DU CONTENU IMPORTÉ (legacy WordPress) ────── */
(function () {
  var body = document.querySelector('.article-body');
  if (!body) return;
  // Chrome de l'ancien thème qui double les éléments déjà fournis par le thème Orak
  body.querySelectorAll(
    'section.block-resources, .breadcrumb, .cover-list-categories, meta, [class*="bg-cover"]'
  ).forEach(function (el) { el.remove(); });
  // Titre H1 dupliqué (déjà affiché dans le header de l'article)
  var h1 = body.querySelector('h1');
  if (h1) h1.remove();
  // Tableaux : suppression des dimensions inline + wrapper pour scroll mobile
  body.querySelectorAll('table').forEach(function (t) {
    t.removeAttribute('width'); t.removeAttribute('height');
    t.style.removeProperty('width'); t.style.removeProperty('height');
    if (t.parentElement && t.parentElement.classList.contains('table-wrap')) return;
    var w = document.createElement('div');
    w.className = 'table-wrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });
  // Paragraphes vides de l'import (<p>&nbsp;</p>, <p><br></p>) : marqués « is-empty ».
  // Ils ne sont masqués que sur mobile (CSS), où ils créaient de grands blancs.
  body.querySelectorAll('p').forEach(function (p) {
    if (p.querySelector('img,picture,video,iframe,svg,input,button')) return;
    if (!p.textContent.replace(/\u00a0/g, '').trim()) p.classList.add('is-empty');
  });
})();

/* ─── TABLE DES MATIÈRES — auto-générée depuis les H2 ─────────── */
(function () {
  var toc = document.getElementById('toc-list');
  if (!toc) return;
  var headings = document.querySelectorAll('.article-body h2');
  if (!headings.length) return;
  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1);
    var item = document.createElement('div');
    item.className = 'toc-item';
    item.textContent = h.textContent;
    item.onclick = function () { h.scrollIntoView({ behavior: 'smooth' }); };
    toc.appendChild(item);
  });
  /* Highlight au scroll */
  var tocItems = toc.querySelectorAll('.toc-item');
  addEventListener('scroll', function () {
    var cur = -1;
    headings.forEach(function (h, i) {
      if (h.getBoundingClientRect().top < 140) cur = i;
    });
    tocItems.forEach(function (item, i) { item.classList.toggle('on', i === cur); });
  }, { passive: true });
})();

/* ─── SHARE ──────────────────────────────────────────────────── */
function shareLinkedIn() {
  window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(location.href), '_blank');
}
function copyLink() {
  navigator.clipboard.writeText(location.href).then(function () {
    var btn = document.querySelector('[onclick="copyLink()"]');
    if (!btn) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '<i class="ti ti-check"></i>Copié !';
    setTimeout(function () { btn.innerHTML = orig; }, 2000);
  });
}

/* ─── SMOOTH SCROLL ancres ───────────────────────────────────── */
document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
  const t = document.querySelector(a.getAttribute('href'));
  if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
}));
